/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="app.common.controllers.module.ts" />
/// <reference path="../../common/iapirequestconfig.ts" />
/// <reference path="../errordetail.ts" />

module App.Common.Controllers {
	'use strict';

	class ErrorController {

		public static $inject = ['$scope', 'model'];

		constructor(
			private $scope: angular.IScope,
			public model: {errorDetails: ErrorDetail[]}) {
			$scope.$on('modal.closing',
			(event: angular.IAngularEvent): void => {
				event.preventDefault();
			});
		}

		public reload(): void {
			document.location.reload(true); //Force non-cached page reload
		}

	}

	angular
		.module('app.common.controllers')
		.controller('app.common.controllers.errorController', ErrorController);
}